import React from 'react';
import './OrderConfirmation.css';

const OrderConfirmation = (props) => {

    if (!props.isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && props.onCancel) {
            props.onCancel();
        }
    };

    const details = [
        { label: 'מספר הזמנה', value: props.orderNumber },
        // { label: 'סכום', value: props.amount != null ? `${props.amount} ${props.currency}` : undefined },
        { label: 'סוג הזמנה', value: props.orderType },
    ].filter((d) => d.value !== undefined && d.value !== null && d.value !== '');

    return (
        <div
            className="ocm-backdrop"
            dir="rtl"
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="ocm-title"
        >
            <div className="ocm-card">
                <div className="ocm-icon-wrap">
                    <svg viewBox="0 0 24 24" className="ocm-icon" aria-hidden="true">
                        <path
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                        />
                    </svg>
                </div>

                <h2 id="ocm-title" className="ocm-title">{props.title}</h2>
                {props.description && <p className="ocm-description">{props.description}</p>}

                {details.length > 0 && (
                    <div className="ocm-details">
                        {details.map((d) => (
                            <div className="ocm-detail-row" key={d.label}>
                                <span className="ocm-detail-value">{d.value}</span>
                                <span className="ocm-detail-label">{d.label}</span>
                            </div>
                        ))}
                    </div>
                )}

                <button
                    type="button"
                    className="ocm-btn ocm-btn-confirm"
                    onClick={props.onConfirm}
                    disabled={props.loading}
                >
                    {props.loading ? 'טוען...' : 'אישור'}
                </button>
                <button
                    type="button"
                    className="ocm-btn ocm-btn-cancel"
                    onClick={props.onCancel}
                    disabled={props.loading}
                >
                    חזור
                </button>
            </div>
        </div>
    );
}
export default OrderConfirmation;